 <template>
  <v-container  grid-list-md  fluid>
    <v-toolbar  color="#FAFAFA" flat >
      <v-btn icon outline color="black" to="/editoras">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title >{{getToolbarName()}}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn color="green" dark @click="salvar()">salvar</v-btn>
    </v-toolbar>

<v-divider></v-divider>
   
   
      <v-layout wrap    fluid grid-list-md white class="px-2 py-2">
       
        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="Nome /Nome Fantasia"
            messages="Nome da Obra que será utilizado para vincular os fonogramas e aumentar a rentabilidade dos compositores."
            v-model="publisher.name"
          />
        </v-flex>

        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="Razão Social"
            messages="Caso seja uma empresa."
            v-model="publisher.br_razao_social"
          />
        </v-flex>

        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="Contato"
            messages="Nome do contato na Editora"
            v-model="publisher.contact_name"
          />
        </v-flex>

        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="E-mail"
            messages="E-mail do contato da editora"
            v-model="publisher.contact_email"
          />
        </v-flex>

        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="Telefone"
            messages="Telefone fixo"
            v-model="publisher.phone"
          />
        </v-flex>

        <v-flex xs6 md6>
          <v-text-field
            class="purple-input"
            label="Celular"
            messages="Celular para agilizar o contato"
            v-model="publisher.cellphone"
          />
        </v-flex>

        <v-flex xs12 md12 v-if="publisher.custom_name">
          <v-text-field
            class="purple-input"
            label="Nome"
            messages="Nome customizado. Enviado através da API."
            v-model="publisher.custom_name"
            disabled
          />
        </v-flex>

       
      </v-layout>
      

   <modal_message
      :dialog_opened="modal_dialog.dialog_opened"
      :title="modal_dialog.title"
      :message="modal_dialog.message"
      :btn_1_text="modal_dialog.btn_1_text"
      :btn_2_text="modal_dialog.btn_2_text"
      @btn_1_clicked="modal_dialog.btn_1_evnt"
      @btn_2_clicked="modal_dialog.btn_1_evnt"
    />
  </v-container>
</template>


<script>
import PublisherService from "../../app/Rest/publishers";
import modal_message from "../../components/shared/modal_message";

var publisherService = null;

export default {
  components: {
    modal_message
  },
  data() {
    return {
      item_id: 0,
      publisher: {},
      modal_dialog: {
        dialog_opened: false,
        title: null,
        message: null,
        btn_1_text: null,
        btn_2_text: null,
        btn_1_evnt: function() {},
        btn_2_evnt: function() {}
      },
    };
  },
  created() {
    publisherService = PublisherService.build();
    this.item_id = this.$route.params.id;
    if(this.item_id){
      publisherService.getOne(this.item_id).then(e=>{
        this.publisher = e.items.publisher;
      })
    }
  },
  methods: {
    getToolbarName(){
      if(this.item_id){
        return "Editar Editora";
      }
      return "Nova Editora";
    },
    salvar() {
      this.$store.dispatch("loading_full");
      publisherService.salvar(this.publisher).then(e=>{
        if(e.items.publisher){
          this.publisher = e.items.publisher;

           
        this.modal_dialog.title = "Salvo com sucesso!";        
        this.modal_dialog.btn_1_text = "obrigado";
        this.modal_dialog.btn_1_evnt = e => {
          this.modal_dialog.dialog_opened = false;          
        };
        
      }else{
        this.modal_dialog.title = "Tivemos um problema, tente novamente.";        
        this.modal_dialog.btn_1_text = "ok";
        this.modal_dialog.btn_1_evnt = e => {
          this.modal_dialog.dialog_opened = false;          
        };
      }     
        this.modal_dialog.dialog_opened = true;

      }).catch( e=>{
         //alert(e.msg);
         console.log(e);         
      }).finally( e =>{
        this.$store.dispatch("loading_full");
      })
    }
  }
};
</script>
